export const I18N_LOCALE_CHANGE = 'i18n-locale-change' as const;
export const I18N_MESSAGES_UPDATE = 'i18n-messages-update' as const;
